import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { handleSmoothScroll } from '../../utils/scrollUtils';
import Logo from '../../assets/images/logo.png'

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('home');
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Update header style when scrolled
            setIsScrolled(window.scrollY > 50);

            // Update active section based on scroll position
            const sections = document.querySelectorAll('section[id]');
            let current = '';

            sections.forEach(section => {
                const sectionTop = section.offsetTop - 100;
                if (window.scrollY >= sectionTop) {
                    current = section.getAttribute('id');
                }
            });

            if (current && current !== activeSection) {
                setActiveSection(current);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeSection]);

    // Navigation Items
    const navItems = [
        { id: 'home', label: 'Home' },
        { id: 'services', label: 'Services' },
        // { id: 'about', label: 'About Us' },
        { id: 'pricing', label: 'Pricing' },
        { id: 'testimonials', label: 'Testimonials' },
        // { id: 'pricing', label: 'Pricing' },
        { id: 'contact', label: 'Contact' }
    ];

    return (
        <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-white shadow-md py-2`}>
            <div className="container mx-auto px-4">
                <nav className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="mr-6">
                            <div className="cursor-pointer" onClick={() => window.location.href = '/'}>
                                <img
                                    src={Logo}
                                    alt="Urban Shine Logo"
                                    loading="lazy"
                                    className={`h-16 transition-all duration-300 ${isScrolled ? 'h-12' : 'h-16'}`}
                                />
                            </div>
                        </div>

                        <ul className="hidden md:flex space-x-8">
                            {navItems.map(item => (
                                <li key={item.id}>
                                    <a
                                        href={`#${item.id}`}
                                        onClick={(e) => handleSmoothScroll(e, () => {
                                            // Optional callback after scrolling completes
                                        })}
                                        className={`text-base font-medium transition-colors duration-300 ${activeSection === item.id
                                            ? 'text-green-700'
                                            : 'text-gray-700 hover:text-green-700'
                                            }`}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="hidden md:flex items-center space-x-4">
                        <button
                            className="px-5 py-2 rounded-full text-base font-medium transition-colors duration-300 bg-green-600 text-white hover:bg-green-700"
                            onClick={(e) => handleSmoothScroll(e, null, 'contact')}
                        >
                            Download Our App
                        </button>
                    </div>
                    <button
                        className="md:hidden transition-colors text-gray-700"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                    </button>
                </nav>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="md:hidden bg-white shadow-lg">
                    <ul className="py-4 px-6 space-y-4">
                        {navItems.map(item => (
                            <li key={item.id}>
                                <a
                                    href={`#${item.id}`}
                                    className={`block text-base font-medium ${activeSection === item.id ? 'text-green-700' : 'text-gray-700'}`}
                                    onClick={(e) => {
                                        handleSmoothScroll(e, () => setIsMenuOpen(false));
                                    }}
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                        <li className="pt-4">
                            <button className="w-full px-5 py-2 bg-green-600 text-white rounded-full text-lg font-medium hover:bg-green-700 transition-colors"
                                onClick={() => {
                                    setIsMenuOpen(false);
                                    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                                }}
                            >
                                Download Our App
                            </button>
                        </li>
                        <li>
                            <button className="w-full px-5 py-2 border border-green-600 text-green-600 rounded-full text-lg font-medium hover:bg-green-600 hover:text-white transition-colors"
                                onClick={() => {
                                    setIsMenuOpen(false);
                                    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                                }}
                            >
                                Contact Us
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </header>
    );
};

export default Header;